const name = 'circle-l';


const contents = `
<circle cx="31" cy="41" r="29"/>
<path fill="#FFF" d="M40.239 55H21.761V26.829h5.635V50.36h12.843z"/>
`;


/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'L',
};

export default icon;
